import { useTranslate } from "@similarweb/i18n-provider";
import { AlertBanner } from "@similarweb/ui-components";
import { Box } from "@similarweb/ui-components/foundations";

import { formatNumberWithComa } from "app/pages/sales-intelligence/utils/leads";

import { DEAL_SIGNAL_MAX_COMPANIES } from "../../constants";
import signalRecommenderI18nKeys from "../../utils/i18n";

import type { DealSignalCsvValidationError } from "./types";

type UploadValidationErrorProps = {
    error?: DealSignalCsvValidationError;
};

export const UploadValidationError = ({ error }: UploadValidationErrorProps) => {
    const { translate } = useTranslate();

    if (!error) {
        return null;
    }

    const tooManyCompanies = signalRecommenderI18nKeys.upload.error.tooManyCompanies({
        count: formatNumberWithComa(error.companiesCount),
        limit: formatNumberWithComa(DEAL_SIGNAL_MAX_COMPANIES),
    });

    const renderMessage = () => {
        switch (error.reason) {
            case "tooManyCompanies":
                return translate(tooManyCompanies.key, tooManyCompanies.replacements);
            case "noDataRows":
                return translate(signalRecommenderI18nKeys.upload.error.noDataRows);
            default:
                return translate(signalRecommenderI18nKeys.upload.error.generic);
        }
    };

    return (
        <Box padding="24px 0 0">
            <AlertBanner
                variant="error"
                data-automation="signal-recommender-upload-error"
            >
                <AlertBanner.Image />
                <AlertBanner.Description>{renderMessage()}</AlertBanner.Description>
            </AlertBanner>
        </Box>
    );
};
